import * as React from "react";
import PortalPanel from "components/shared/PortalPanel";

const Landing: React.FC<{ imagePath: string; onGoNext: () => void }> = ({
  imagePath,
  onGoNext,
}) => {
  return (
    <PortalPanel
      image={imagePath}
      title="Welcome to Marble"
      primaryButton={{
        text: "Sign In",
        action: onGoNext,
      }}
    >
      <p className="text-center">
        Marble lets you view and manage the apps connected to your health data.
      </p>
    </PortalPanel>
  );
};

export default Landing;
